import type { Offering } from "@/lib/types/database/offerings";
import { ENHANCED_OFFERINGS_CONFIG } from "@/features/offerings/components/EnhancedOfferingsConfig";
import { ENHANCED_OFFERING_DETAIL_CONFIG } from "@/features/offerings/components/OfferingDetailConfig";
import { getFieldValue } from "@/components/shared/UniversalCRMTable/components/SimpleTable/tableCellFieldValue";
import { defineEntity } from "../types";

// ============================================================================
// OFFERINGS ENTITY DEFINITION
// ============================================================================
// Offerings = professional services catalog with pricing and line items.
// Column change: edit features/offerings/components/EnhancedOfferingsConfig.ts.
// New saved view: edit features/offerings/config/offerings-saved-views.ts.
// ============================================================================

export const offeringsEntity = defineEntity<Offering>({
  tableConfig: ENHANCED_OFFERINGS_CONFIG,

  detailConfig: ENHANCED_OFFERING_DETAIL_CONFIG,

  synthesizeField(item, fieldId) {
    return getFieldValue(item, fieldId);
  },
});
